export function candleAtPoint(chart, series, candles, x, y) {
  if (!chart || !series) return null
  const scale = chart.timeScale(), time = scale.coordinateToTime(x)
  const candle = candles.find(bar => bar.time === time)
  if (!candle || !Number.isFinite(candle.high) || !Number.isFinite(candle.low)) return null
  const center = scale.timeToCoordinate(candle.time)
  const high = series.priceToCoordinate(candle.high), low = series.priceToCoordinate(candle.low)
  if (center == null || high == null || low == null) return null
  const halfWidth = Math.max(2, (scale.options?.().barSpacing || 6) * 0.4)
  return Math.abs(x - center) <= halfWidth && y >= Math.min(high, low) - 2 && y <= Math.max(high, low) + 2 ? candle : null
}
